import React from "react";
import { Helmet } from "react-helmet";
import homebackground from './../image/banner.png';

const Recruiting = () => {
  return (
    <div className="w-full h-auto bg-white flex flex-col items-center justify-center lg:mt-20 sm:mt-0">
      <Helmet>
        <title> Recruiting - Nexify Infosystems</title>
        <meta name="description" content="Explore Nexify's recruiting process and discover the skills that make a great recruiter." />
        <meta name="keywords" content="Nexify, recruiting, talent acquisition, careers, hiring process, recruitment, HR" />
      </Helmet>
      <div
        className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${homebackground})` }}
      >
        {/* Black Overlay */}
        {/* <div className="absolute inset-0 bg-black opacity-50"></div> */}
        <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
          <div
            className="opacity-0 translate-y-10 animate-slideUp bg-[#0c5495b3] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14"
            style={{
              animation: "slideUp 1s ease-in-out forwards",
              animationDelay: "2s",
            }}
          >
            <h1 className="text-[8vw] md:text-[66px] font-semibold mb-2 break-words">
              Nexify Recruiting
            </h1>
            <h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
              Connecting talent, empowering growth, building success.
            </h2>

          </div>
        </div>
      </div>
      <div className="w-full max-w-[1320px] px-4 mx-auto mt-20 mb-20">

        <h2 className="mb-6 text-[#0e55a8] lg:text-[40px] text-[30px] leading-[1.8] font-[700] text-left">
          Recruiting
        </h2>
        {/* Paragraph Content Section */}
        <div className="mt-10 text-[#222] text-[18px] leading-7">
          <p className="mb-6">
            **Five signs that indicate you are skilled at recruiting talent:**
         </p>

          <div className="mb-6">
            <h3 className="font-[700] text-[20px] text-[#222] mb-4">1. You Consistently Find the Right Fit</h3>
            <p className="flex items-start">
              <span className="text-[16px] text-[#6d6d70] leading-[1.8]">
                You successfully hire candidates who match both the role requirements and company culture, leading to high retention and strong contributions. This reflects your ability to evaluate technical skills, cultural alignment, and long-term potential.
              </span>
            </p>
        </div>
          <div className="mb-6">
            <h3 className="font-[700] text-[20px] text-[#222] mb-4">2. You Build Strong Talent Pipelines</h3>
            <p className="flex items-start">
              <span className="text-[16px] text-[#6d6d70] leading-[1.8]">
                You proactively maintain a network of qualified candidates, ensuring quick and efficient hiring. This reduces time-to-hire and helps secure top talent when roles open.
              </span>
            </p>
        </div>
          <div className="mb-6">
            <h3 className="font-[700] text-[20px] text-[#222] mb-4">3. You Excel at Candidate Engagement</h3>
            <p className="flex items-start">
              <span className="text-[16px] text-[#6d6d70] leading-[1.8]">
                Your clear communication and professionalism create a positive candidate experience, increasing offer acceptance rates and strengthening your reputation as a recruiter.
              </span>
            </p>

          </div>
          <div className="mb-6">
            <h3 className="font-[700] text-[20px] text-[#222] mb-4">
              4. You Adapt to Changing Needs and Markets
            </h3>
            <p className="flex items-start">
              <span className="text-[16px] text-[#6d6d70] leading-[1.8]">
                You stay informed on industry trends and job market shifts, adjusting strategies to attract top talent and stay competitive in evolving hiring landscapes.
              </span>
            </p>
          </div>
          <div>
            <h3 className="font-[700] text-[20px] text-[#222] mb-4">
              5. You Leverage Data and Technology Effectively
            </h3>
            <p className="flex items-start">
              <span className="text-[16px] text-[#6d6d70] leading-[1.8]">
                You utilize ATS, analytics, and recruitment tools to streamline hiring, track success, and refine strategies, leading to better hiring decisions and outcomes.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recruiting;
